import { ReviewRatingTypeFilterButtons } from "@/components/reviews";
import type { ReviewType } from "@/services/bedrock";
import { cn } from "@/lib/utils";
import { ReviewRatingValueFilter } from "./ReviewRatingValueFilter";
import type { CoachNpsCategoryFilter, CoachRecommendationFilter } from "./useCoachReviewFilters";

type CoachRatingFilterFieldsProps = {
  ratingType: ReviewType | null;
  onRatingTypeChange: (ratingType: ReviewType | null) => void;
  ratingValue: number | null;
  onRatingValueChange: (value: number | null) => void;
  npsCategory: CoachNpsCategoryFilter | null;
  onNpsCategoryChange: (category: CoachNpsCategoryFilter | null) => void;
  recommendation: CoachRecommendationFilter | null;
  onRecommendationChange: (value: CoachRecommendationFilter | null) => void;
  valueFilterClassName?: string;
};

export function CoachRatingFilterFields({
  ratingType,
  onRatingTypeChange,
  ratingValue,
  onRatingValueChange,
  npsCategory,
  onNpsCategoryChange,
  recommendation,
  onRecommendationChange,
  valueFilterClassName,
}: CoachRatingFilterFieldsProps) {
  return (
    <>
      <ReviewRatingTypeFilterButtons value={ratingType} onChange={onRatingTypeChange} />
      {ratingType ? (
        <div className={cn("flex flex-col gap-2", valueFilterClassName)}>
          <ReviewRatingValueFilter
            ratingType={ratingType}
            value={ratingValue}
            onChange={onRatingValueChange}
            npsCategory={npsCategory}
            onNpsCategoryChange={onNpsCategoryChange}
            recommendation={recommendation}
            onRecommendationChange={onRecommendationChange}
          />
        </div>
      ) : null}
    </>
  );
}
